import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      data-slot="skeleton"
      // className={cn("bg-accent animate-pulse rounded-md", className)}
      className={cn("animate-pulse bg-gray-300/90 rounded-md", className)}
      {...props} />
  );
}

export { Skeleton }
